import { Component, Input } from '@angular/core';
import { NgElement, WithProperties } from '@angular/elements'
import 'leaflet.tilelayer.pouchdbcached'
import { ScoutPath, ScoutPoint } from '../../../core/models/scout-task';
import { ScoutMarkerPopupComponent } from './scout-marker-popup.component';
import { AppState } from '../../../core';
import {LookupService, ScoutPointPhotoService} from '../../../core/services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PathPlotterComponent } from '../../../shared/mapping/path-plotter/path-plotter.component';
import { Point } from '../../../core/models/point';

@Component({
  selector: 'app-scout-path-plotter',
  templateUrl: '../../../shared/mapping/path-plotter/path-plotter.component.html',
  styleUrls: ['../../../shared/mapping/path-plotter/path-plotter.component.scss']
})
export class ScoutPathPlotterComponent extends PathPlotterComponent<ScoutPoint> {

  @Input() newPointFn : (sp:ScoutPoint,childOffset) => ScoutPoint;
  @Input() buildingPoints : Point[]

  scoutPath: ScoutPath

  constructor(
      appState: AppState,
      lookupService: LookupService,
      photoService: ScoutPointPhotoService,
      modalService: BsModalService) {
    super(appState,lookupService,photoService,modalService)
    this.markerPopupInitFn = this.scoutPointMarkerPopupInitFn
  }

  scoutPointMarkerPopupInitFn = (startPoint:ScoutPoint) => {
    return (fl) => {
      const popupComp: NgElement & WithProperties<ScoutMarkerPopupComponent> = document.createElement('app-marker-popup-element') as any;
      popupComp.addEventListener('closed', () => document.body.removeChild(popupComp));
      popupComp.pt = startPoint
      popupComp.selectedPt = this.scoutPath.scoutPoints[this.selectedIndex]
      popupComp.changeGuard = this.changeGuard
      popupComp.deleteScoutPointFn = this.deletePointFn
      popupComp.setSelectedPointFn = this.setSelectedPoint
      popupComp.bShowSelectButton = this.canSelectViaPoints || startPoint.type != 'VIA'
      popupComp.showRefDataFn = this.showRefDataFn
      popupComp.newScoutPointFn = this.newPointFn
      popupComp.scoutPath = this.scoutPath
      popupComp.buildingPoints = this.buildingPoints
      popupComp.allowEditMode = this.allowEditMode
      popupComp.locked = this.locked
      document.body?.appendChild(popupComp);
      const rtn : any = popupComp
      return rtn
    }
  }

  plotScoutPath( scoutPath : ScoutPath ) {
    this.scoutPath = scoutPath
    this.plot(scoutPath?.scoutPoints)
  }

  plotScoutPathWhenReady( scoutPath : ScoutPath ) {
    this.scoutPath = scoutPath
    this.plotWhenReady(scoutPath?.scoutPoints)
  }

}
